import { getFramework, IFramework, IHistoryItem } from '@/framework';
import { traverseTrees } from '@/utils/tree-kit';
import { ILayerProps, IMainLayerProps, LayerType } from '@/version-types';

export const historyKey = 'StageCrop';

export const resetStage = (framework: IFramework, originLayers: ILayerProps[]) => {
    traverseTrees(originLayers, (layer: ILayerProps) => {
        framework.stage.addOrUpdate({ ...layer });
    });
};

export interface IHistoryItemData {
    oldData: ILayerProps[];
    newData: ILayerProps[];
    isAdjust: boolean;
}

export class StageCropHistory {
    constructor(identity: string) {
        const framework = getFramework(identity);

        framework.history.register(historyKey, {
            onRedoUndo: (historyItem: IHistoryItem<IHistoryItemData>, isRedo, isUndo) => {
                const data = historyItem.data.data;

                if (isUndo) {
                    resetStage(framework, data.oldData);
                }

                if (isRedo) {
                    resetStage(framework, data.newData);
                }

                const oldMainLayerData = data.oldData.find((layer) => layer.layerType === LayerType.MAIN_LAYER)
                    ?.data as IMainLayerProps | undefined;
                const newMainLayerData = data.newData.find((layer) => layer.layerType === LayerType.MAIN_LAYER)
                    ?.data as IMainLayerProps | undefined;

                // ATTENTION: 舞台要整个重新渲染，才可以让插件中的 RenderStage 可以再次更新，才可以渲染舞台的蒙版裁剪效果
                if (oldMainLayerData?.maskURL !== newMainLayerData?.maskURL) {
                    framework.setRerender(framework.stage.getActiveOriginIndex());
                    framework.rerender();
                }
            },
            onMessage: () => {
                // [todo] 图片编辑器，舞台裁剪多人协同，不需要处理
            },
        });
    }
}
